<ds-configuration-search-page *ngIf="configuration" class="w-100"
                              [fixedFilterQuery]="searchFilter"
                              [configuration]="configuration"
                              [searchEnabled]="searchEnabled"
                              [showCharts]="true">
</ds-configuration-search-page>
